module.exports = __webpack_public_path__ + "img/home_rent_declartion.b0eb0cbb.svg";